import { clone } from 'lodash'
import { Alert } from '@/api'
import { dataStore } from '@/utils/store-accessor'
export class AlertFactory {
  static create(code: string, ...args: string[]): Alert {
    const result: Alert = clone(dataStore.findAlertByCode(code))

    args.forEach(
      (arg, index) =>
        (result.message = result.message.replace(`{${index}}`, arg))
    )

    return result
  }
}
